export const REVIEW_FORM_FIELDS = {
  NAME: 'author-name',
  EMAIL: 'author-email',
  CONTENT: 'content',
  RATING: 'rating',
}